import { render } from "./CreateOppModal.vue?vue&type=template&id=0c3f7668"
import script from "./CreateOppModal.vue?vue&type=script&lang=js"
export * from "./CreateOppModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__